<template>
	<div class="header-bg">
		<div class="header-container">
	    <div class="d-flex header-top header-bar__top-line align-items-center">
        <div class="header-logo align-content-center">
            <a class="logo-link logo-link-black" href="https://iarc.who.int/" title="IARC"></a>
        </div>
        <div class="site-name-wrapper d-md-flex">
        	<a href="https://gco.iarc.who.int" target="_blank" v-if="website_hide_gco==false">
        		<img class="gco_logo" src="./assets/img/GCO-logo.png" alt="Global Cancer Observatory" title="Global Cancer Observatory">
        	</a>
					<div class="site-name">
						<a :href="website_url">
							<img class="website-logo" v-if="website_logo!=''" :src="website_logo" :title="website_title" />
						</a>
						<span v-if="website_logo==''">{{ website_title }}</span>
					</div>

					<div class="site-name-short">
						<a :href="website_url">
							<img class="website-mobile-logo" :src="website_mobile_logo" :title="website_title" />
						</a>
					</div>
				</div>
	    	<div class="header-lang d-lg-flex">
			      <div class="btn-newsletter">
			          <a href="https://www.iarc.who.int/iarcnewsletter/" class="subscribe-button">iarc newsletter</a>
			      </div>
			      <div class="btn-donations-custom">
			          <a href="https://www.iarc.who.int/donations/" class="support-button">Donate now</a>
			      </div>
	      </div>
      	<div class="burger"></div>
	    </div>
		</div>
	</div><!-- End header bg -->
</template>

<script>

export default {
  name: 'HeaderTop',
  components: {

  },
  props : {
    website_hide_gco : { type : Boolean , default : false } ,
    website_logo : { type : String } , 
    website_mobile_logo : { type : String } , 
    website_url : { type : String } , 
    website_title : { type : String } ,
    menus : { type : Array  } , 
    submenu : { type : Array }
  },
  data () {
    return {
    	route : ''
    }
  },
  mounted () { 
  	this.route = this.$router.currentRoute.path
  }
}
</script>

<style lang="scss">

img.website-logo,img.website-mobile-logo{
	display: none 
}

.site-name-short{
	display: none; 
}

.header-lang{
	.btn-newsletter,.btn-donations-custom{
		opacity: 0 ; 
	}
}

@media screen and (min-width: 1251px){
	img.website-logo{
		display: block
	}
}

@media screen and (max-width: 1251px){
	
	.site-name-short{
		display: block ; 
		img.website-mobile-logo{
			max-height: 70px;
			display: block
		}
	}
}

</style>